module.exports = __webpack_public_path__ + "static/img/videoimg.87d8e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/videoimg.png
// module id = mY4v
// module chunks = 2